// extracted by mini-css-extract-plugin
export default {"property":"MetadataListProperty_property__SYqSo","list":"MetadataListProperty_list__r5yy3","content":"MetadataListProperty_content__DA0qh"};